var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdsTileLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#cbd4e3;}.cls-2{fill:#fff;}.cls-3{fill:#ae8fea;}.cls-4,.cls-7{fill:#784ace;}.cls-5{fill:#e6e6e6;}.cls-6,.cls-8{fill:#5735aa;}.cls-7,.cls-8,.cls-9{opacity:0.5;}.cls-9{fill:#4f2984;}.cls-10{fill:none;stroke:#ffa068;stroke-linecap:round;stroke-miterlimit:10;stroke-width:30px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_150",
    "data-name": "Layer 150"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M387.45,221.21c31.68,49,54.26,96.65,64.2,132.24,6.92,24.7,7.75,43.58,1.35,53.05,0,0,0,0,0,.05h0c-13.12-2.38-27.67-4.42-43.36-5.67-12.76-8.63-27.27-21.54-42.54-37.8-9.36-10-19-21.18-28.7-33.47-1.77-2.22-3.52-4.48-5.29-6.77-10.81-14-21.62-29.36-32.16-45.66-10.69-16.51-20.35-32.88-28.81-48.69-1.37-2.56-2.71-5.08-4-7.6-13.24-25.53-23.28-49.37-29.58-69.74a201.41,201.41,0,0,1-5.63-22.43A403.82,403.82,0,0,0,245.21,85.6s0-.1,0-.15a0,0,0,0,1,.06,0s0,0,0,0h0c4.16-.71,9.08,0,14.65,2C291.16,98.73,341.92,150.83,387.45,221.21Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 317.7,
    cy: 270.89,
    r: 62.26
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M453,406.5l.11.08a.22.22,0,0,0-.11,0v0h0c-13.12-2.38-27.67-4.42-43.36-5.67-3.12-.26-6.28-.46-9.49-.64a400.81,400.81,0,0,0-58.47.85c-72,6.35-124.83,31.28-157.56,51.13L97.86,318.92c31.23-23.8,73.69-63.77,107.52-127.24a439.32,439.32,0,0,0,24.36-54.19c1.1-3,2.15-5.88,3.15-8.76A403.82,403.82,0,0,0,245.21,85.6s0-.1,0-.15a.47.47,0,0,0,0-.14s0,.1,0,.14,0,.06,0,.08,0,0,0,0c1.59,9,3.64,19.19,6.32,30.27a492.66,492.66,0,0,0,32.56,92.93c.59,1.26,1.19,2.53,1.82,3.8s1.17,2.49,1.79,3.73c1.28,2.62,2.59,5.26,3.95,7.91l1.52,3c.87,1.68,1.74,3.34,2.65,5Q302.23,244,309.56,256c7.67,12.58,15.64,24.38,23.76,35.39q2.15,2.93,4.32,5.76c2.14,2.83,4.3,5.63,6.47,8.36s4.35,5.41,6.53,8c1.79,2.16,3.59,4.31,5.39,6.39.9,1.06,1.81,2.08,2.7,3.12,7.22,8.26,14.44,15.94,21.54,23.09Q387,352.89,393.5,359A490.54,490.54,0,0,0,453,406.5Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "245.37 85.44 245.35 85.45 245.36 85.42 245.37 85.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M429.65,421.92a.27.27,0,0,0-.15,0l-.45-.09.32-.09.16.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M97.86,318.92,184,452,99.48,506.67a24.11,24.11,0,0,1-29.11-2.51,23.47,23.47,0,0,1-4.06-4.76L6.41,406.8a23.67,23.67,0,0,1-3.11-7.17,24.07,24.07,0,0,1,10.27-26.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M14.72,419.11,62.64,493.2l-9,5.82c-4.48,2.9-11.72-.35-16.16-7.22L5.68,442.63c-4.45-6.88-4.43-14.8,0-17.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M154,471.43l62.71,96.94a12.49,12.49,0,0,1-3.89,17.24l-18.36,11.88a15.29,15.29,0,0,1-19.95-2.74l-66-77.52-9-10.56Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "153.95 471.43 172.77 500.52 108.47 517.23 99.48 506.67 153.95 471.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M429.53,421.84l.12.08a.27.27,0,0,0-.15,0l-.45-.09.32-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M400.12,400.25a400.81,400.81,0,0,0-58.47.85c-72,6.35-124.83,31.28-157.56,51.13l-14.52-22.45c2.76-1.44,5.53-2.85,8.35-4.28a679.2,679.2,0,0,1,181.8-61.1A493.24,493.24,0,0,0,400.12,400.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M169.57,429.78,184,452,99.48,506.67a24.11,24.11,0,0,1-29.11-2.51,23.47,23.47,0,0,1-4.06-4.76l-1.32-2c.23-.17.43-.34.65-.51A674.27,674.27,0,0,1,169.57,429.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M453.07,406.61l.12.08-.15,0a18.76,18.76,0,0,1-1.65,1.44,33.46,33.46,0,0,1-40.78.22q-5.08-3.79-10.49-8.08a493.24,493.24,0,0,1-40.4-35.85q3.7-.67,7.35-1.31,13.53-2.38,26.4-4.1l0,0A490.54,490.54,0,0,0,453,406.5l.11.08a.22.22,0,0,0-.11,0S453,406.6,453.07,406.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M453.19,406.69l-.15,0a18.76,18.76,0,0,1-1.65,1.44,33.46,33.46,0,0,1-40.78.22q-5.08-3.79-10.49-8.08a493.24,493.24,0,0,1-40.4-35.85c-9.87-9.75-20-20.53-30-32.41-.87-1-1.72-2.05-2.58-3.08-1-1.24-2.05-2.48-3.06-3.74A488.25,488.25,0,0,1,286,271.25c-7.34-12-13.87-23.93-19.66-35.59h0c-1.36-2.66-2.62-5.29-3.88-7.92-.59-1.21-1.17-2.42-1.73-3.63a492.32,492.32,0,0,1-25.22-65.87c-2.18-7.18-4.1-14.12-5.78-20.74-1.24-4.86-2.36-9.57-3.38-14.08a33.3,33.3,0,0,1,17.26-37.13,12.84,12.84,0,0,1,1.59-.68.21.21,0,0,1,.11,0s0,0,0,0,0-.06,0-.08a.2.2,0,0,1,0,.11c1.59,9,3.62,19.12,6.28,30.17a489.77,489.77,0,0,0,32.56,93s0,.09,0,.12c.58,1.24,1.15,2.46,1.75,3.69s1.18,2.48,1.79,3.73c1.28,2.62,2.59,5.26,3.95,7.91l1.52,3c.88,1.67,1.74,3.34,2.65,5Q302.23,244,309.56,256c7.67,12.58,15.64,24.38,23.76,35.39,1.43,1.95,2.85,3.88,4.32,5.76,2.14,2.83,4.3,5.63,6.47,8.36s4.32,5.43,6.51,8.06c0,0,.07.06.09.09,1.77,2.13,3.53,4.24,5.3,6.29.9,1.06,1.8,2.09,2.72,3.11,7.2,8.27,14.41,16,21.54,23.09q6.66,6.75,13.2,12.82A491.61,491.61,0,0,0,453,406.55v0s0,0,.07,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M51.14,474.44l19.23,29.72a35.24,35.24,0,0,1-3.82-4.91l-3.91-6.05-9,5.82c-4.48,2.9-11.72-.35-16.16-7.22l-3.89-6Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 584.72,
    y1: 88.73,
    x2: 449.32,
    y2: 181.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 423.07,
    y1: 18.33,
    x2: 386.21,
    y2: 134.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 465.82,
    y1: 263.52,
    x2: 585.72,
    y2: 255.19
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdsTileLogo);
export default __webpack_public_path__ + "static/media/ads_tile_logo.54f437102d8674f9cdaf4e2a84739bd9.svg";
export { ForwardRef as ReactComponent };